module.exports = __webpack_public_path__ + "img/home-robotarm.104acf04.png";